export default __webpack_public_path__ + "static/media/logo_only_face.a7fd3511.svg";